export const DE = {
    primitive: {
        thousandSeparator: ".",
        decimalSeparator: ",",
    },
    numberSuffix: {
        billion: "Mrd",
        million: "Mio",
    },
    pager: {
        page: "Seite:",
        linesPerPage: "Zeilen pro Seite:",
        linesFromTo: (from, to, total) => `${from} - ${to} von ${total}`,
    },
    error: {
        confirmButton: "Schließen",
        defaultTitle: "Fehler",
        defaultHint: "Aufgrund eines unerwarteten Fehlers konnte Ihre Anfrage leider nicht verarbeitet werden. ",
        serverError: "Bitte versuchen Sie es später erneut.",
        networkError: "Es bestehen Verbindungsprobleme, bitte überprüfen Sie die Netzwerkverbindung und versuchen es später erneut.",
        messageWithFlowId: (flowId) => `Wir haben diesen Fehler prokolliert und kümmern uns um eine Lösung. Für eventuelle Rückfragen geben Sie bitte die Fehlerreferenz ${flowId} mit an.`,
    },
    breadcrumb: {
        title: "Sie befinden sich hier",
    },
    validation: {
        textTooLong: (maxAllowed) => `Bitte geben Sie maximal ${maxAllowed} Zeichen ein.`,
        textTooShort: (minRequired) => `Bitte geben Sie mindestens ${minRequired} Zeichen ein.`,
        date: {
            formatMismatch: (format) => `Das angegebene Datum entspricht nicht dem vorgegebenem Format (${format}).`,
        },
        notANumber: "Bitte geben Sie eine Zahl ein.",
        required: "Bitte geben Sie einen Wert ein.",
        min: (min) => `Ihre Zahl ist zu klein (erwartet ≥ ${min}).`,
        max: (max) => `Ihre Zahl ist zu groß (erwartet ≤ ${max}).`,
        integer: "Bitte geben Sie eine Ganzzahl ein.",
    },
    offerState: {
        notyetcompleted: "Nicht vollständig",
        published: "Veröffentlicht",
        publishedincomplete: "Erfasst",
        cannotvaluate: "Kann nicht bewertet werden",
        readybutcannotvaluate: "Bereit zur Veröffentlichung, kann aber nicht bewertet werden",
        readytopublish: "Bereit zur Veröffentlichung",
        ownoffer: "Eigenes Angebot",
        nostatepresent: "Keine Vorkenntnis oder Erstnachweis",
        firstrecord: "Erstnachweis erstellt",
        previousknowledge: "Vorkenntnis erklärt",
        onbehalfof: "Intern erfasst",
    },
    revoHeader: {
        backButton: "Zurück",
    },
};
//# sourceMappingURL=de.js.map